import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const ContainerPropsSchema = z.object({
    style: z
        .object({
        backgroundColor: COLOR_SCHEMA,
        borderColor: COLOR_SCHEMA,
        borderRadius: z.number().optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
});
function getBorder(style) {
    if (!style || !style.borderColor) {
        return undefined;
    }
    return `1px solid ${style.borderColor}`;
}
export function Container({ style, children }) {
    var _e, _t;
    const wStyle = {
        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _e !== void 0 ? _e : undefined,
        border: getBorder(style),
        borderRadius: (_t = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _t !== void 0 ? _t : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    if (!children) {
        return React.createElement("div", { style: wStyle });
    }
    return React.createElement("div", { style: wStyle }, children);
}
//# sourceMappingURL=Container.js.map